import { formatDate } from '@utils';

export const normalizeCampaigns = (data = []) => {
  if (!data.length > 0) {
    return [];
  }

  const campaigns = data.map((item) => {
    const currentDate = new Date().toISOString();

    return {
      ...item,
      id: item?.id,
      createdAt: item?.createdAt
        ? formatDate(item?.createdAt, 'dd/MM/yyyy HH:mm')
        : '-',
      createdBy: item?.createdBy || '-',
      updatedAt: item?.updatedAt
        ? formatDate(item?.updatedAt, 'dd/MM/yyyy HH:mm')
        : '-',
      updatedBy: item?.updatedBy || '-',
      startingAt: item?.startingAt
        ? formatDate(item?.startingAt, 'dd/MM/yyyy HH:mm')
        : '-',
      endingAt: item?.endingAt
        ? formatDate(item?.endingAt, 'dd/MM/yyyy HH:mm')
        : '-',
      description: item?.description || '-',
      isActive:
        item?.endingAt === null ||
        (currentDate > item?.startingAt && currentDate < item?.endingAt),
    };
  });

  return campaigns;
};
